// UNDRIVE Configuration
export const PROFILE_IMAGE = "https://customer-assets.emergentagent.com/job_content-flash/artifacts/gah8iwmi_Profilbild_Dominik.jpeg";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const B2B_PORTAL_URL = process.env.REACT_APP_B2B_PORTAL_URL;
export const DEALER_CONSULTING_URL = process.env.REACT_APP_DEALER_CONSULTING_URL;
